<template>
  <f7-app v-bind="f7params" color-theme="orange">
    <!-- Your main view, should have "view-main" class -->
    <f7-view
      browserHistory
      browserHistorySeparator=""
      stackPages
      main
      class="safe-areas"
      url="/"
    ></f7-view>
  </f7-app>
</template>
<script>
import { ref, onMounted } from "vue";
import { f7, f7ready } from "framework7-vue";

import routes from "../js/routes.js";
import store from "../js/store";

export default {
  setup() {
    // Framework7 Parameters
    const f7params = {
      // App id
      id: "com.koipy.shop",
      name: "可派外卖商户端", // App name
      theme: "ios", // Automatic theme detection
      // App store
      store,
      // App routes
      routes,
    };
    onMounted(() => {
      f7ready(() => {
        // Call F7 APIs here
      });
    });

    return {
      f7params,
    };
  },
};
</script>